import { __extends } from "tslib";
import { SceneLoader } from "../../Loading/sceneLoader.js";
import { WebVRController } from "./webVRController.js";
import { PoseEnabledControllerHelper } from "./poseEnabledController.js";
/**
 * Generic Controller
 */
var GenericController = /** @class */ (function (_super) {
    __extends(GenericController, _super);
    /**
     * Creates a new GenericController from a gamepad
     * @param vrGamepad the gamepad that the controller should be created from
     */
    function GenericController(vrGamepad) {
        return _super.call(this, vrGamepad) || this;
    }
    /**
     * Implements abstract method on WebVRController class, loading controller meshes and calling this.attachToMesh if successful.
     * @param scene scene in which to add meshes
     * @param meshLoaded optional callback function that will be called if the mesh loads successfully.
     */
    GenericController.prototype.initControllerMesh = function (scene, meshLoaded) {
        var _this = this;
        SceneLoader.ImportMesh("", GenericController.MODEL_BASE_URL, GenericController.MODEL_FILENAME, scene, function (newMeshes) {
            _this._defaultModel = newMeshes[1];
            _this.attachToMesh(_this._defaultModel);
            if (meshLoaded) {
                meshLoaded(_this._defaultModel);
            }
        });
    };
    /**
     * Called once for each button that changed state since the last frame
     * @param buttonIdx Which button index changed
     * @param state New state of the button
     */
    GenericController.prototype._handleButtonChange = function (buttonIdx, state) {
        console.log("Button id: " + buttonIdx + "state: ");
        console.dir(state);
    };
    /**
     * Base Url for the controller model.
     */
    GenericController.MODEL_BASE_URL = "https://controllers.babylonjs.com/generic/";
    /**
     * File name for the controller model.
     */
    GenericController.MODEL_FILENAME = "generic.babylon";
    return GenericController;
}(WebVRController));
export { GenericController };
PoseEnabledControllerHelper._DefaultControllerFactory = function (gamepadInfo) { return new GenericController(gamepadInfo); };
//# sourceMappingURL=genericController.js.map